import { Controller } from "@hotwired/stimulus"
import CalendarMessageAssignationModal from "@components/calendar-messages/assignation-modal.svelte"
import { mount, unmount } from "svelte"

const COMPONENT_KEY = "__svelteComponent"

// Connects to data-controller="calendar-messages-assignation"
export default class extends Controller {
  connect() {
    this.mountComponent()

    // Turbo can restore cached snapshots/previews where Stimulus doesn't necessarily reconnect
    // in the way you expect; re-mount on each turbo:load to keep the dropdown working.
    if (this.afterLoad) document.removeEventListener("turbo:load", this.afterLoad)
    this.afterLoad = () => {
      if (!this.component && this.element.isConnected) this.mountComponent()
    }
    document.addEventListener("turbo:load", this.afterLoad)

    if (this.beforeCache) document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.beforeCache = () => this.teardown()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    if (this.afterLoad) {
      document.removeEventListener("turbo:load", this.afterLoad)
      this.afterLoad = null
    }
    if (this.beforeCache) {
      document.removeEventListener("turbo:before-cache", this.beforeCache)
      this.beforeCache = null
    }
    this.teardown()
  }

  mountComponent() {
    this.teardown()
    const clinicId = this.element.dataset.clinicId

    const component = mount(CalendarMessageAssignationModal, {
      target: this.element,
      props: {
        clinicId,
      },
    })
    this.component = component
    this.element[COMPONENT_KEY] = component
  }

  teardown() {
    const existing = this.element[COMPONENT_KEY] || this.component
    if (existing) unmount(existing)
    this.element[COMPONENT_KEY] = null
    this.component = null
    this.element.innerHTML = ""
  }
}
